export default "__VITE_ASSET__ZnEvPvxU__"